/**
 * Fetches document metadata from the parent JSP
 */
export const fetchDocumentMetadata = (
  document: Document,
  name: string,
  defaultResponse: string | null = null,
): string | null => {
  if (document.querySelector("meta[name='" + name + "']") !== null) {
    const response = (
      document.querySelector("meta[name='" + name + "']") as HTMLMetaElement
    )?.content;

    return response === '' || typeof response === 'undefined'
      ? defaultResponse
      : response;
  }

  return defaultResponse;
};

/**
 * Fetches document metadata from the parent JSP as an integer
 */
export const fetchDocumentMetadataAsInt = (
  document: Document,
  name: string,
  defaultResponse: null | number = null,
): number | null => {
  const response = fetchDocumentMetadata(
    document,
    name,
    defaultResponse?.toString(),
  );

  if (response !== null) {
    return parseInt(response);
  }

  return response;
};
